import { useParams } from 'react-router-dom';
import { FileX2 } from 'lucide-react';

import { DOCUMENT_TYPE } from '@/app/document/enums';
import DocumentPreview from '@/app/document/DocumentPreview';

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Card, CardContent } from '@/components/ui/card';
import Loader from '@/components/common/Loader';

import { useCoachActivity } from '@/data/coachActivity';
import { useDocuments } from '@/data/document';
import { useUserActivityWaiver } from '@/data/userActivityWaiver';

const WaiverPreview = () => {
  const params = useParams();
  const coachActivity = useCoachActivity(params.coachActivityId);
  const userActivityWaiver = useUserActivityWaiver(
    coachActivity.data.userId,
    coachActivity.data.activityId
  );
  const waiverDocuments = useDocuments({
    type: DOCUMENT_TYPE.WAIVER,
    userActivityWaiverId: userActivityWaiver.data.id
  });

  if (waiverDocuments.isLoading && !waiverDocuments.data) {
    return <Loader />;
  }

  const waiverDocument = waiverDocuments.data.find(
    (doc) => doc.userId === coachActivity.data.userId
  );

  return (
    <div>
      {!waiverDocument && (
        <Alert>
          <FileX2 className="h-4 w-4" />
          <AlertTitle>No Waiver Found</AlertTitle>
          <AlertDescription>
            The document waiver cannot be found.
          </AlertDescription>
        </Alert>
      )}
      {waiverDocument && (
        <Card className="flex-auto overflow-hidden">
          <CardContent className="p-0 h-[80vh]">
            <DocumentPreview document={waiverDocument} />
          </CardContent>
        </Card>
      )}
    </div>
  );
};

export default WaiverPreview;
